import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/Home.vue'
import Globe from '../components/globe/Globe.vue'
import Africa from '../components/africa/Dashboard.vue'
import VueApexCharts from 'vue-apexcharts'
var SocialSharing = require('vue-social-sharing')

Vue.use(VueRouter)
Vue.use(require('vue-moment'))
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
Vue.use(SocialSharing)

const routes = [
  {
    path: '/',
    component: Home
  },
  {
    path: '/globe',
    component: Globe
  },
  {
    path: '/africa',
    component: Africa
  },
  { path: "*",
    component: Home 
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
